import {
  CATEGORIES,
  SET_PAGINATION,
  PURGE_PAGINATION,
  SET_SEARCH_QUERY,
  PURGE_SEARCH_QUERIES,
  SET_SEARCH_RESULTS,
  PURGE_SEARCH_RESULTS,
  SET_CATEGORIES,
  PURGE_CATEGORIES,
  PREPEND_SEARCH_RESULTS
} from './searchModule.types'

function defaultPagination () {
  return {
    current_page: null,
    first_item: null,
    last_item: null,
    next_page_url: null,
    prev_page_url: null,
    per_page: null
  }
}

function defaultSearchQuery () {
  return {
    search: null,
    sortBy: null,
    sortOrder: null
  }
}

function defaultCategory () {
  return {
    name: 'default',
    pagination: defaultPagination(),
    query: defaultSearchQuery(),
    results: []
  }
}

const state = {
  categories: [defaultCategory()]
}

const getters = {
  [CATEGORIES] (state) {
    return state.categories
  }
}

const mutations = {
  [SET_PAGINATION] (state, pagination) {
    let category = state.categories.find((el) => {
      return el.name === pagination.categoryName
    })

    if (category) {
      category.pagination = pagination.data
    } else {
      category = defaultCategory()
      category.name = pagination.categoryName
      category.pagination = pagination.data
      state.categories.push(category)
    }
  },

  [PURGE_PAGINATION] (state, categoryName) {
    let category = state.categories.find((el) => {
      return el.name === categoryName
    })

    if (category) {
      category.pagination = defaultPagination()
    }
  },

  [SET_SEARCH_QUERY] (state, searchQuery) {
    let category = state.categories.find((el) => {
      return el.name === searchQuery.categoryName
    })

    if (category) {
      category.query = searchQuery.data
    } else {
      category = defaultCategory()
      category.name = searchQuery.categoryName
      category.query = searchQuery.data
      state.categories.push(category)
    }
  },

  [PURGE_SEARCH_QUERIES] (state, categoryName) {
    let category = state.categories.find((el) => {
      return el.name === categoryName
    })

    if (category) {
      category.query = defaultSearchQuery()
    }
  },

  [SET_SEARCH_RESULTS] (state, searchResults) {
    let category = state.categories.find((el) => {
      return el.name === searchResults.categoryName
    })

    if (category) {
      category.results = searchResults.data
    } else {
      category = defaultCategory()
      category.name = searchResults.categoryName
      category.results = searchResults.data
      state.categories.push(category)
    }
  },

  [PURGE_SEARCH_RESULTS] (state, categoryName) {
    let category = state.categories.find((el) => {
      return el.name === categoryName
    })

    if (category) {
      category.results = []
    }
  },

  [SET_CATEGORIES] (state, categoryName) {
    let category = state.categories.find((el) => {
      return el.name === categoryName
    })

    if (!category) {
      category = defaultCategory()
      category.name = categoryName
      state.categories.push(category)
    }
  },

  [PURGE_CATEGORIES] (state) {
    state.categories = [defaultCategory()]
  },

  [PREPEND_SEARCH_RESULTS] (state, data) {
    let category = state.categories.find((el) => {
      return el.name === data.categoryName
    })

    if (category) {}
    category.results.unshift(data.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/search/searchModule.js